<div class="vendortitlecon">
  <h1 class="vendortitle text-center m-0">{{ getTranslation('agreement.title') }}</h1>
</div>
<div class="vendorcodedescription">


  <div *ngIf="isJsonShow">
    {{aggrementForm.value | json}}
  </div>



  <div class="agreement-container">
      <ul>
        <li>
          {{ getTranslation('agreement.clause1') }}
        </li>
        <li>
          {{ getTranslation('agreement.clause2') }}
        </li>
        <li>
          {{ getTranslation('agreement.clause3') }}
        </li>
        <li>
          {{ getTranslation('agreement.clause4') }}
        </li>
        <li>
          {{ getTranslation('agreement.clause5') }}
        </li>
        <li>
          {{ getTranslation('agreement.clause6') }}
        </li>
        <li>
          {{ getTranslation('agreement.clause7') }}
        </li>
        <li>
          {{ getTranslation('agreement.clause8') }}
        </li>
        <li>
          <b>{{ getTranslation('agreement.clause9') }}</b>
        </li>
      </ul>
    </div>
    




 
<!-- </div> -->


<div class="vendortitlecon mb-2">
  <h1 class="vendortitle text-center m-0 ">{{ getTranslation('agreement.acknowledgement.title') }}</h1>
</div>
<!-- <div class="vendorcodedescription"> -->

  <div class="agreement-container">
      <ol>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause1') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause2') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause3') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause4') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause5') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause6') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause7') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause8') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause9') }}
        </li>
        <li>
          {{ getTranslation('agreement.acknowledgement.clause10') }}
        </li>
      </ol>
    </div>
    


</div>



 <form [formGroup]="aggrementForm" >


 <div class="chkbox-cont">
  <div class="vendorformchk ml-0">
    <input type="checkbox" formControlName="IsAggrementAccepted"   name="IsAggrementAccepted" /> {{ getTranslation('agreement.declaration') }}

  </div>
</div>















<div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive"  *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    
    <button type="button" class="btn nextbtn" [disabled]="this.aggrementForm.get('IsAggrementAccepted')?.value == false || this.aggrementForm.get('IsAggrementAccepted')?.value == null" (click)="proceed()" >{{ getTranslation('agreement.button.submit') }}</button>
</div>



</form>






<!-- // this.route.navigate(['/applicant/seva-profile']) -->